// Main – simplyfied
import {
  getCurrentLanguage,
} from "./kb-cart-personalisation-conf.js?v=20260407";

import {
  updateCartForEngravingsStart,
  updateCartForEngravings2,
} from "./kb-cart-personalisation-cart-sync.js?v=20260407";

import {
  initCartHandlers,
  refreshCartUI,
  refreshCartExtras,
} from "./kb-cart-personalisation-ui.js?v=20260407";

//--------------------------------------------------
// Simply hash blocking
//--------------------------------------------------

const originalFetch = window.fetch;
window.fetch = (url, options) => url?.includes?.('/cart.js') && url.includes('hash=') 
  ? Promise.resolve({ ok: true, json: () => Promise.resolve({ items: [] }) })
  : originalFetch(url, options);

//--------------------------------------------------
// Start script
//--------------------------------------------------
document.addEventListener('DOMContentLoaded', async () => {
  const loader =
    document.getElementById('ajaxBusy') ||
    document.querySelector('#cart-loader');

  try {
    if (loader) loader.style.display = 'block';

    // 1  sync & delete & create engraving / zentrum) /
    await updateCartForEngravingsStart({ loader });

    // 2️  new cart markup /
    const html = await fetch(theme.routes_cart_url, { cache: 'no-store' })
                         .then(r => r.text());
    CartReload(html);                 

  } catch (err) {
    console.error('❌ Initial cart sync failed:', err);
  } finally {
    if (loader) loader.style.display = 'none';
  }

  // 3️  other handlers from theme add here, not in initCartHandlers()*/
});
